<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.basic200.pb-0
        v-row(no-gutters)
          v-col
            h6.mb-0.basic800--text {{ $t('update_xendit') }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="default" :size="24") mdi-close

      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")

            .registered(v-if="gatewayId")
              div This account is managed by Xendit. Go to Xendit dashboard to view payout status or update account information.
              v-layout.mt-3
                v-btn.primary(block depressed @click="viewXenditDashboard(loginUrl)") Xendit Dashboard
              v-divider.my-5

            .registered-email
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('email.label') }}
              v-text-field.p1(solo flat background-color="basic200" height="40" v-model='accountEmail' :label="$t('email.label')" :placeholder="$t('email.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")

            .account-list
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 Account List
              .empty(v-if="accountList.length === 0")
                v-card.pa-4(flat outlined)
                  .caption No account found for this email. Register your Xendit account here:
                  v-btn.primary.my-2(small block depressed @click="clickRegister" height="32") Register
                  .c1.mt-3.basic600--text *Your Xendit account activation will take some time due to Xendit verification process. This may take up to 24 hours. An email/sms will be sent when your Xendit account is ready.
              .list(v-else)
                .list-item.my-2
                  v-row(v-for='account in accountList' :key="account.id" no-gutters align="center")
                    v-col.shrink(@click="selectedAccount = account.id")
                      v-btn(icon small)
                        template(v-if="selectedAccount === account.id")
                          v-icon(color='success') mdi-check-circle
                        template(v-else)
                          v-icon(color='primary400') mdi-radiobox-blank
                    v-col
                      span.ml-1 {{ account.public_profile.business_name }}
                        span.c1.ml-1(v-if="account.status !== 'LIVE'")
                          span (
                          span.danger--text {{ account.status }}
                          span )

                  .c1.mt-2(v-if="accountList.filter(f => f.status !== 'LIVE').length > 0") Your Xendit account activation will take some time due to Xendit verification process. This may take up to 24 hours. An email/sms will be sent when your Xendit account is ready.

      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-small(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave' :disabled="!selectedAccount || accountList.length === 0")
          | {{ $t('update') }}
    y-dialog(fill-height fluid v-model="showRegisterModal" scrollable transition="fade-transition" persistent max-width="300px")
      v-card(v-if="!registerDone")
        v-card-title
          span.body-1.font-weight-bold Register Xendit Account
        v-card-text
          v-form(ref="registerForm" lazy-validation @submit.prevent)
            .register-email
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 Email address
              v-text-field.p1(solo flat background-color="basic200" height="40" v-model='registerEmail' :label="$t('email.label')" placeholder="Enter email address" outlined dense persistent-hint :rules="rules.valid_email" :error-messages="registerErrors")
        v-card-actions
          v-spacer
          v-btn.button-AA-small(color='primary400', text @click='showRegisterModal = false' :disabled="isRegisterLoading")
            | {{ $t('cancel') }}
          v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isRegisterLoading" @click='clickConfirmRegister')
            | {{ $t('confirm') }}
      v-card(v-else)
        v-card-title
          span.body-1.font-weight-bold Register Xendit Account
        v-card-text
          div Please check your inbox ({{this.registerEmail}}) and open invitation email sent by Xendit.
        v-card-actions
          v-spacer
          v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 @click='showModal = false') Close

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'UpdateXendit',
  props: ['open', 'company'],
  data: () => ({
    showRegisterModal: false,
    isFetching: true,
    gatewayId: null,
    accountEmail: null,
    registerEmail: '',
    accountList: [],
    selectedAccount: null,
    businessName: null,
    registerUrl: process.env.VUE_APP_XENDIT_REGISTER_URL,
    loginUrl: 'https://dashboard.xendit.co/login',
    isLoading: false,
    isRegisterLoading: false,
    registerErrors: [],
    registerDone: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    accountEmail (email) {
      this.fetchAccounts(email)
    }
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/xendit_creds/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const gateway = response.data.results[0]
          this.gatewayId = gateway.id
          this.accountEmail = gateway.account.email
          this.selectedAccount = gateway.account.id
          this.businessName = gateway.account.public_profile.business_name
        }
        this.isFetching = false
      })
    },
    fetchAccounts(email) {
      this.$axios.get('/xendit_accounts/', {params: {email}}).then((response) => {
        this.accountList = response.data.results
      })
      .catch(() => {
        this.accountList = []
      })
    },
    clickRegister () {
      this.registerEmail = this.accountEmail
      this.showRegisterModal = true
    },
    clickConfirmRegister () {
      this.registerErrors = null
      if (!this.$refs.registerForm.validate()) {
        return
      }
      this.isRegisterLoading = true
      this.$axios.post('/xendit_accounts/', {company: this.company.id, email: this.registerEmail})
      .then(resp => {
        this.accountList = [resp.data]
        this.registerDone = true
      }).catch(e => {
        this.registerErrors = e.response.data
      }).finally(() => {
        this.isRegisterLoading = false
      })
    },
    viewXenditDashboard (url) {
      window.open(url)
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('account', this.selectedAccount)
      if (this.gatewayId) {
        this.axios.put(`/xendit_creds/${this.gatewayId}/`, params)
        .then(() => {
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/xendit_creds/`, params)
        .then(resp => {
          this.$emit('activated', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
</style>

<i18n>
{
  "en": {
    "update_xendit": "Xendit",
    "email": {
      "label": "Registered Xendit Email",
      "placeholder": "Fill email registered in Xendit"
    },
    "account_list": {
      "label": "Account List",
      "placeholder": "Write your secret key here"
    },
    "cancel": "Cancel",
    "update": "Save",
    "confirm": "Confirm"
  }
}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
